// extracted by mini-css-extract-plugin
module.exports =  {"granteeCellWrapper":"granteeCellWrapper__VxXtA","iconGroup":"iconGroup__gm5HT"};